import * as React from 'react';
import SimpleModalSlideshow from 'react-modal-slideshow';

interface ISlides {
    media: string;
    content: string;
}

interface IProps {
    images: string[];
}

interface IState {
    open: boolean;
    currentSlide: number;
}


export class Gallery extends React.Component<IProps, IState> {
    slides = [];
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            currentSlide: 0,
        };

        // Create the slides that will be needed for the gallery app
        // The media must be react components, so we have to create them in the js itself
        props.images.forEach(i => {
            this.slides.push({
                media: (
                    <img src={i} />
                ),
                content: ''
            });
        })
    }


    handlePrev = (index) => {
        this.setState({
            currentSlide: index,
        });
    }

    handleNext = (index) => {
        this.setState({
            currentSlide: index,
        });
    }

    handleClose = () => {
        this.setState({
            open: false,
        });
    }

    openSlideshow = (index) => {
        this.setState({
            open: true,
            currentSlide: index,
        });
    }
    render() {
        return (
            <div>
                <div className="react-gallery">
                    {
                        this.props.images.map((image, index) => (
                            <div
                                className="react-gallery-img"
                                key={index}
                                onClick={this.openSlideshow.bind(this, index)}>
                                <img src={image} />
                            </div>
                        ))
                    }
                </div>
                <SimpleModalSlideshow
                    slides={this.slides}
                    currentSlide={this.state.currentSlide}
                    open={this.state.open}
                    onClose={this.handleClose}
                    onNext={this.handleNext}
                    onPrev={this.handlePrev}
                    classNamePrefix="cpg-slideshow"
                />
            </div>
        );
    }
}